module.exports = __webpack_public_path__ + "static/media/Spooky Girl.1ee3cce5.jpg";